<template>
  <div class="home">
    <div class="homePC">
      <header>
        <img :src="config.icon && config.icon != '' ? config.icon : require('@/assets/img/logo.png')">
        <el-button @click="routerJump()"><img src="@/assets/img/back.png" alt=""> 返回 人才地图</el-button>
      </header>
      <main>
        <aside>
          <img src="../assets/img/asideTitle.png" alt="">
          <ul>
            <li @click="addNewChat()"><i class="el-icon-plus"></i>新对话</li>
          </ul>
          <ul ref="chatHistory">
            <li
              v-for="(item, index) in getFilteredHistoryList()"
              :key="index"
              :class="{ active: chooseHistory == index && historyList[0][0].content !== '请输入问题' }"
              @click="getDefaultChat(index)"
            >
              <el-tooltip v-if="item[0].content.length > 12" class="item" effect="light" :content="item[0].content" placement="right">
                <span class="textHidden">{{ item[0].content }}</span>
              </el-tooltip>
              <span v-else class="textHidden">{{ item[0].content }}</span>
            </li>
          </ul>
        </aside>
        <article>
          <div class="artHeader">
            <div class="artBox" ref="messageContainer">
              <div class="tip">
                <img src="../assets/img/tipOne.png" alt="">
                <div class="tipBox">
                  <P class="textHidden"><e>Hi ~</e> 我是 “圳好懂” 机器人～</P>
                  <span class="textHidden">您好，很高兴为您服务，有什么问题您可以问我哦，我会尽力为您解答！</span>
                  <div class="tipBtn">
                    <span @click="defaultSend(item)" v-for="(item, i) in defaultTitleList[0].questionList" :key="i"><u></u>{{ item }}</span>
                  </div>
                </div>
              </div>
              <div v-for="(item, index) in messages[currentChatId]" :key="index" :class="item.role === 'user' ? 'questionBox' : 'answerBox'">
                <div class="contentBox">
                  <div>
                    <img v-if="item.role !== 'user'" src="@/assets/img/AI.png" alt="">
                    <div class="messageP">
                      <p v-html="item.content"></p>
                      <!-- <p v-if="item.role !== 'user' && index === 0">
                        <span @click="defaultSend(item)" v-for="(item, i) in defaultTitleList[0].questionList" :key="i"><u></u>{{ item }}</span>
                      </p> -->
                      <span v-if="item.loading && item.role !== 'user'" class="loadingDots"></span>
                      <span v-if="item.loading && item.role !== 'user'" class="loadingDots2"></span>
                      <span v-if="item.loading && item.role !== 'user'" class="loadingDots3"></span>
                      <!-- 猜你想问 -->
                      <div v-if="item.role !== 'user' && item.guessList && item.guessList.length > 0" class="guessBox">
                         <i @click="defaultSend(res)" v-for="(res, i) in item.guessList" :key="i">{{ res }}</i>
                       </div>
                      <span @click="copyText(item.content)" class="botCopy" v-if="item.role === 'assistant' && item.loading == false && index !== 0">
                        <i class="el-icon-copy-document"></i>复制
                      </span>
                    </div>
                    <img v-if="item.role === 'user'" src="@/assets/img/user.jpg" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="artFooter" :class="{'focused': isFocused}">
            <div>
              <el-input type="textarea" placeholder="输入您的问题或需求，按 Enter 发送" maxlength="1500" v-model="question" @keydown.native="inpSend($event)"  @focus="onFocus" @blur="onFocus"></el-input>
              <img v-if="isSending === false" @click="send" src="../assets/img/send.png">
              <img v-else @click="stopMessage" src="../assets/img/nosend.png">
            </div>
          </div>
        </article>
      </main>
      <!-- 全屏显示组件 -->
      <div class="fullscreenOverlay" :class="{ active: showFullscreen }" @click="closeFullscreen">
        <div :style="{ backgroundImage: 'url(' + fullscreenImage + ')' }"></div>
        <i class="el-icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
// import { questionTemplateApi } from '@/api';
import { marked } from 'marked';
export default {
  name: 'HelloWorld',
  data() {
    return {
      randomChatId: '',
      // 可配置项------------------------
      config: {
        icon: '',
        token: 'fastgpt-yLPjfBAMT5LiKu8hd4sJSEU2tzozibGsRhe5JJkps3c2kiA18jfBI',
        appId: '6892b8c019d977b74d8109b8'
      },
      // -------------------------------
      newAnswer: '', // 回答
      historyList: [], // 历史对话列表
      chooseHistory: 0, // 是否是移动端
      isFocused: false, // 输入框是否聚焦
      fullscreenImage: '',
      showFullscreen: false, // 全屏显示标识
      chooseDialogBox: 1, // 选中的配置方式
      currentChatId: 'as2Bind2OEfAiqKve6w5GLiCWPw3YZPZPtebIpHzmBHmgmDCGNeJ0EMXqiIQyxD', // 当前选中的对话框
      appId: '6892b8c019d977b74d8109b8',
      question: '',
      messages: {}, // 存储不同对话框的消息
      isLoading: false,
      isSending: false, // 发送状态标识
      isStopped: false, // 停止标识
      abortController: null, // AbortController实例
      chooseTitle: 0, // 选择的历史对话框
      titleList: [],
      defaultTitleList: [{
        chatId: 'as2Bind2OEfAiqKve6w5GLiCWPw3YZPZPtebIpHzmBHmgmDCGNeJ0EMXqiIQyxD',
        content: '',
        questionList: ['你是谁?', '如何使用这个系统?']
      }],
      drawer: false,
    };
  },
  mounted() {
    // 1.根据网址链路信息获取参数
    // const urlParams = new URLSearchParams(window.location.search);
    // const queryParams = {};
    // urlParams.forEach((value, key) => {
    //   queryParams[key] = value;
    // })
    // this.config = queryParams
    this.getHistory()
    this.randomChatId = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
  },
  methods: {
    getFilteredHistoryList() {
      return this.historyList.filter(item => item[0].content !== '请输入问题');
    },
    // 路由跳转
    routerJump() {
      // 跳转一个新的网页
      window.location.href = 'https://szrs.innogate.com.cn'
    },
    // 新增对话
    addNewChat() {
      this.randomChatId = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
      if (this.historyList[this.historyList.length - 1][0].content !== '请输入问题') {
        
        if (this.historyList[0][0].content !== '请输入问题') {
          this.historyList.unshift([{ role: 'user', content: '请输入问题' }])
        }
        this.chooseHistory = 0
        this.messages[this.currentChatId] = []
        this.getDefaultTitle(0)
        this.$forceUpdate()
        this.$nextTick(() => {
          this.scrollToBottom2()
        })
      } else {
        this.historyList[this.chooseHistory].splice(0, 1)
        this.getDefaultChat(this.historyList.length - 1)
        this.getDefaultTitle(0)
      }
    },
    // 本地缓存历史数据
    getHistory() {
      if (window.localStorage.getItem('historyList')) {
        this.historyList = JSON.parse(window.localStorage.getItem('historyList'))
        this.chooseTitle = 0
        this.getDefaultChat(this.chooseTitle)
        this.getDefaultTitle(0)
      } else {
        this.historyList = [[{ role: 'user', content: '请输入问题' }]]
        this.getDefaultTitle(0)
      }
    },
    onFocus() {
      this.isFocused = !this.isFocused;
    },
    // 获取猜你想问参数
    async getSuggest() {
      const url = '/api/core/ai/agent/v2/createQuestionGuide'
      const headers = {
        Authorization: 'Bearer fastgpt-yLPjfBAMT5LiKu8hd4sJSEU2tzozibGsRhe5JJkps3c2kiA18jfBI',
        'Content-Type': 'application/json',
      }
      const data = {
        appId: this.appId,
        chatId: this.randomChatId === '' ? this.currentChatId : this.randomChatId
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const res = await response.json()
        this.$set(this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1], 'guessList', res.data)
        this.$forceUpdate()
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    // 选中图片
    selectImage(index) {
      switch (index) {
        case 1:
          this.fullscreenImage = require('@/assets/img/1.png');
          break;
        case 2:
          this.fullscreenImage = require('@/assets/img/2.png');
          break;
        case 3:
          this.fullscreenImage = require('@/assets/img/3.png');
          break;
      }
      this.showFullscreen = true;
    },
    closeFullscreen() {
      this.showFullscreen = false;
    },
    // 获取问答内容
    getDefaultChat(index) {
      if (this.historyList[index][0].content !== '请输入问题') {
        this.messages[this.currentChatId] = JSON.parse(JSON.stringify(this.historyList[index]))
      } else {
        this.messages[this.currentChatId] = []
      }
      this.chooseHistory = index
      this.$forceUpdate()
      this.getDefaultTitle(0)
      // this.scrollToBottom()
    },
    // 获取默认问答标题
    async getDefaultTitle(index) {
      if (index === 0) {
        // 获取初始问答内容
        const url = '/api/core/chat/init?chatId=' + this.currentChatId + '&appId=' + this.config.appId;
        const headers = {
          Authorization: 'Bearer fastgpt-yLPjfBAMT5LiKu8hd4sJSEU2tzozibGsRhe5JJkps3c2kiA18jfBI',
          'Content-Type': 'application/json',
        }
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: headers,
          });
          if (!response.ok) {
            throw new Error('网络响应错误');
          }
          const res = await response.json()
          const welcomeText = res.data.app.chatConfig.welcomeText;
          const parsedText = welcomeText.split('\n');
          console.log(parsedText[0], parsedText.map(question => question.slice(1, -1)), res.data.app.name)
          // // 标题
          this.defaultTitleList[0].content = parsedText[0]
          // // 内容
          this.defaultTitleList[0].questionList =  parsedText.map(question => question.slice(1, -1))
          // 发起默认会话
          // this.changeChat(this.defaultTitleList[0], 0)
        } catch (error) {
          console.error('请求失败:', error)
        }
      }
      this.$forceUpdate()
      // this.scrollToBottom()
    },
    copyConfig(index) {
      let textToCopy;
      if (index === 1) {
        textToCopy = 'https://aq.pogpt.cn?token=(填入token)&appId=(填入appId)&icon=(填入图标地址)'
      } else if (index === 2) {
        textToCopy = '<iframe src="https://aq.pogpt.cn?token=(填入token)&appId=(填入appId)&icon=(填入图标地址)" style="width: 100%; height: 100%;" frameborder="0" allow="*"></iframe>'
      }
      // 创建一个临时的 textarea 元素用于复制文本
      const textarea = document.createElement('textarea')
      textarea.value = textToCopy
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('复制成功!')
    },
    parseMarkdown(content) {
      return marked(content);
    },
    stopMessage() {
      if (this.isSending) {
        this.isStopped = true;
        if (this.abortController) {
          this.abortController.abort();
        }
        const lastMessage = this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1];
        lastMessage.content = '已停止生成';
        lastMessage.loading = false;
        this.isSending = false;
      }
    },
    changeChat(result) {
      if (!this.messages[result.chatId]) {
        this.messages[result.chatId] = []
      }
      if (this.messages[result.chatId].length === 0) {
        // 配置对应的默认回答
        this.messages[result.chatId].push({
          role: 'assistant',
          content: `${result.content}`,
          loading: false,
        })
        console.log(this.messages[result.chatId])
        this.$forceUpdate()
      }
      this.drawer = false
    },
    clearCurrentChat() {
      if (!this.currentChatId) return false
      // 停止会话
      this.stopMessage()
      // 重新设置chartId
      this.titleList[this.chooseTitle].chatId = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
      this.currentChatId = this.titleList[this.chooseTitle].chatId
      this.messages = [];
    },
    inpSend(event) {
      if (event.key === 'Enter') {
        if (!event.shiftKey) {
          event.preventDefault();
          this.send();
        }
      }
    },
    // 默认回答
    defaultSend(defaultQuestion) {
      this.question = defaultQuestion
      this.send()
    },
    // 发送会话
    async send() {
      if (!this.question.trim() || this.isLoading) return
      this.abortController = new AbortController()
      this.isStopped = false
      this.isSending = true
      if (!this.currentChatId) {
        alert('请先选择一个会话或创建新会话')
        return;
      }
      if (!this.messages[this.currentChatId]) {
        this.messages[this.currentChatId] = [];
      }
      this.messages[this.currentChatId].push({
        role: 'user',
        content: this.question
      });
      this.messages[this.currentChatId].push({
        role: 'assistant',
        content: '',
        loading: true,
      });
      this.scrollToBottom()
      this.isLoading = true;
      const userMessage = this.question;
      this.question = '';
      const url = '/api/v1/chat/completions';
      // const url = 'http://116.148.212.170:7708/api/v1/chat/completions';
      const headers = {
        Authorization: 'Bearer fastgpt-yLPjfBAMT5LiKu8hd4sJSEU2tzozibGsRhe5JJkps3c2kiA18jfBI',
        'Content-Type': 'application/json',
      };
      const data = {
        stream: true,
        chatId: this.randomChatId === '' ? this.currentChatId : this.randomChatId,
        messages: [{ role: 'user', content: userMessage }],
        variables: [{ name: 'cese', uid: '990880' }],
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
          signal: this.abortController.signal,
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let lastMessage = this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1];
        let markdownContent = ''; // 累积完整的 Markdown 内容
        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (this.isStopped) break;
          const { done, value } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value);
          const lines = chunk.split('\n').filter((line) => line.trim());
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const dataStr = line.slice(6);
              if (dataStr === '[DONE]') {
                lastMessage.loading = false;
                break;
              }
              try {
                const parsedData = JSON.parse(dataStr)
                const content = parsedData.choices[0]?.delta?.content || ''
                markdownContent += content; // 累积 Markdown 内容
                // 使用 marked 库将 markdown 转换为 html
                // const htmlContent = marked(markdownContent);
                const htmlContent = marked(markdownContent, { sanitize: false })
                this.$set(lastMessage, 'content', htmlContent)
                // this.$set(lastMessage, 'content', lastMessage.content + content)
                this.newAnswer = lastMessage.content
                this.$forceUpdate()
                this.scrollToBottom()
              } catch (e) {
                console.error('解析数据错误:', e)
              }
            }
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('请求已被中止');
        } else {
          console.error('请求失败:', error);
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].content = '发生错误，请重试';
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].loading = false;
        }
      } finally {
        if (this.historyList[this.chooseHistory][0].content == '请输入问题') {
          this.historyList[this.chooseHistory].splice(0, 1)
        }
        this.historyList[this.chooseHistory].push({ role: 'user', content: data.messages[0].content })
        this.historyList[this.chooseHistory].push({ role: 'assistant', content: this.newAnswer, loading: false })
        // 判断数组有没有大于等于6条如果大于等于6条就,删除最后一条数组
        if (this.historyList.length >= 6 && this.historyList[0][0].content !== '请输入问题') {
          this.historyList.splice(this.historyList.length -1, 1)
        }
        window.localStorage.setItem('historyList', JSON.stringify(this.historyList))
        this.isLoading = false;
        this.isSending = false;
        this.abortController = null;
        // this.currentChatId = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
        this.getSuggest()
      }
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer
        if (container) {
          container.scrollTop = container.scrollHeight
        }
        const container2 = this.$refs.messageContainer2
        if (container) {
          container2.scrollTop = container2.scrollHeight
        }
      })
    },
    // 历史记录滚动到底部
    scrollToBottom2() {
      this.$nextTick(() => {
        const container = this.$refs.chatHistory
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    copyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text || this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('复制成功')
    },
  },
};
</script>

<style scoped lang="less">
.home {
  .homePC {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 20px 58px;
    width: 100%;
    min-width: 1050px;
    height: 100vh;
    background: url('http://img.spolicy.com/FocmRf3_24bs9IVAQqQHsEswi9OD') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    header {
      margin-bottom: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 46px;
      width: 100%;
      >img {
        margin: 0 15px 0 27px;
        height: 46px;
      }
      .el-button {
        padding: 0 23px 0 19px;
        width: 175px;
        height: 36px;
        background: linear-gradient( 270deg, #FFFFFF 0%, #D9EEFF 100%);
        box-shadow: 1px 1px 4px 0px rgba(20,120,204,0.32);
        border-radius: 18px;
        font-weight: 500;
        font-size: 16px;
        color: rgb(20, 120, 204);
        img {
          width: 16px;
          height: 16px;
          vertical-align: -5%;
        }
      }
      .el-button:hover {
        box-shadow: 1px 1px 8px 0px rgba(20,120,204,0.32);
        color: rgba(20, 120, 204, .7);
      }
    }
    main {
      display: flex;
      justify-content: space-between;
      height: calc(100vh - 160px);
      width: 90%;
      box-sizing: border-box;
      border: 2px solid #fff;
      border-radius: 22px;
      overflow: hidden;
      aside {
        padding: 30px 20px;
        display: flex;
        flex-direction: column;
        width: 240px;
        box-sizing: border-box;
        background: url('../assets/img/aside.png') no-repeat;
        background-size: cover;
        background-position: bottom;
        >img {
          margin-bottom: 35px;
          width: 103px;
          height: 21px;

        }
        ul:nth-child(2) {
          margin-bottom: 60px;
          li {
            display: flex;
            align-items: center;
            padding: 0 16px;
            height: 42px;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #FFFFFF;
            line-height: 42px;
            text-align: left;
            font-size: 15px;
            font-weight: bold;
            color: rgba(20, 120, 204, 1);
            cursor: pointer;
            i {
              margin-right: 10px;
              font-weight: bold;
              font-size: 16px;
            }
          }
          li:hover {
            color: rgba(20, 120, 204, .7);
          }
        }
        ul:nth-child(3) {
          height: calc(100vh - 560px);
          overflow: auto;
          margin-bottom: 60px;
          li {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            padding: 0 16px;
            height: 42px;
            background: rgba(255, 255, 255, 0.50);
            border-radius: 8px;
            border: 1px solid rgba(255, 255, 255, 0.50);;
            line-height: 42px;
            text-align: left;
            font-size: 15px;
            font-weight: bold;
            color: rgba(20, 120, 204, 1);
            cursor: pointer;
            i {
              margin-right: 10px;
              font-weight: bold;
              font-size: 16px;
            }
          }
          li:hover {
            border: 1px solid rgba(20, 120, 204, 1);
            color: rgba(20, 120, 204, .7);
          }
          .active {
            border: 1px solid rgba(20, 120, 204, 1);
          }
        }
      }
      article {
        width: calc(100% - 240px);
        display: flex;
        flex-direction: column;
        height: 100%;
        background: linear-gradient( 180deg, #FBFDFF 0%, #F1F9FF 100%);
        backdrop-filter: blur(10px);
        .artHeader {
          flex: 1;
          .artBox {
            .tip  {
              margin: 38px 0 42px;
              display: flex;
              height: 168px;
              width: 100%;
              img {
                margin: 0 2% 0 5%;
                width: 80px;
                height: 68px;
              }
              .tipBox {
                margin-right: 5%;
                width: 80%;
                background: url('../assets/img/tipTwo.png') no-repeat;
                background-size: 100% 100%;
                box-sizing: border-box;
                text-align: left;
                p {
                  margin: 19px 0 8px 32px;
                  font-size: 22px;
                  font-weight: bold;
                  color: rgba(20, 120, 204, 1);
                  e {
                    margin-right: 12px;
                    font-style: italic;
                  }
                }
                span {
                  margin: 0 32px;
                  display: block;
                  color: rgba(20, 120, 204, 1);
                  font-size: 14px;
                  font-weight: bold;
                }
                .tipBtn {
                  margin-top: 31px;
                  display: flex;
                  span {
                    margin: 0 12px 0 22px;
                    padding: 4px 8px 2px 12px;
                    background: url('../assets/img/tipTwo.png') no-repeat;
                    background-size: 200% 200%;
                    border-radius: 16px;
                    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
                    cursor: pointer;
                  }
                  span:hover {
                    color: rgb(208, 130, 83);
                    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1) inset;
                  }
                }
              }
            }
            padding: 0 30px 30px;
            height: calc(100vh - 318px);
            overflow: auto;
            .questionBox {
              margin-bottom: 24px;
              .contentBox {
                width: 100%;
                span {
                  display: block;
                  font-size: 12px;
                  font-weight: bold;
                  color: #ccc;
                }
                >div {
                  margin-left: 30%;
                  display: flex;
                  justify-content: right;
                  align-items: center;
                  width: 70%;
                  .messageP {
                    margin-top: 5px;
                    padding: 10px 15px;
                    background: linear-gradient( 158deg, #1478CC 0%, #177CCE 0%, #51CBFF 100%);
                    border-radius: 12px 0px 12px 12px;
                    border: .0625rem solid rgb(228, 231, 237);
                    line-height: 25px;
                    font-size: 15px;
                    font-weight: bold;
                    color: #fff;
                    text-align: left;
                  }
                  img {
                    margin-left: 14px;
                    width: 44px;
                    height: 44px
                  }
                }
              }
            }
            .answerBox {
              margin-bottom: 24px;
              .contentBox {
                width: 100%;
                span {
                  display: block;
                  font-size: 12px;
                  font-weight: bold;
                  color: #ccc;
                }
                >div {
                  display: flex;
                  justify-content: left;
                  align-items: top;
                  width: 70%;
                  .messageP {
                    margin-top: 5px;
                    padding: 10px 15px;
                    background: rgba(233, 241, 252, 1);
                    border-radius: 0px 12px 12px 12px;
                    line-height: 25px;
                    font-size: 15px;
                    font-weight: bold;
                    color: #333;
                    text-align: left;
                    p {
                      span {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        color: #333;
                        font-size: 14px;
                        font-weight: bold;
                        u {
                          margin-right: 6px;
                          display: inline-block;
                          width: 6px;
                          height: 6px;
                          border-radius: 50%;
                          background-color: #333;
                        } 
                      }
                      span:hover {
                        color: #4887F9;
                        u {
                          background-color: #4887F9;
                        }
                      }
                    }
                    .guessBox {
                      display: flex;
                      flex-wrap: wrap;
                      i {
                        margin: 4px 12px 4px 0;
                        padding: 6px 15px;
                        box-sizing: border-box;
                        border-radius: 30px;
                        border: 1px solid rgb(225, 226, 229);
                        cursor: pointer;
                        font-size: 15px;
                        line-height: 15px;
                        color: rgba(51, 51, 51);
                      }
                      i:hover {
                        border-color: rgb(76, 136, 246);
                        color: rgb(76, 136, 246);
                      }
                    }
                    >span {
                      display: inline-block;
                    }
                    .botCopy {
                      margin-top: 6px;
                      display: block;
                      width: 60px;
                      cursor: pointer;
                      color: #333;
                      i {
                        margin-right: 2px;
                        display: inline-block;
                      }
                    }
                    .botCopy:hover {
                      color: #007bff;
                    }
                  }
                  img {
                    margin-right: 14px;
                    width: 44px;
                    height: 44px
                  }
                }
              }
            }
            .loadingDots, .loadingDots2, .loadingDots3 {
              margin-right: 6px;
              width: 6px;
              height: 6px;
              background-color: #000;
              border-radius: 50%;
              animation: loading 0.8s infinite ease-in-out;
            }
            .loadingDots2 {
              animation: loading2 0.8s infinite ease-in-out;
            }
            .loadingDots3 {
              animation: loading3 0.8s infinite ease-in-out;
            }
            @keyframes loading {
              0% { transform: scale(1.5); }
              50% { transform: scale(1); }
              100% { transform: scale(1); }
            }
            @keyframes loading2 {
              0% { transform: scale(1); }
              50% { transform: scale(1.5); }
              100% { transform: scale(1); }
            }
            @keyframes loading3 {
              0% { transform: scale(1); }
              50% { transform: scale(1); }
              100% { transform: scale(1.5); }
            }
          }
        }
        .artFooter.focused {
          background: linear-gradient(165deg, rgba(81, 203, 255, 1), rgba(20, 120, 204, 1));
        }
        .artFooter {
          position: relative;
          margin: 0 40px 30px;
          padding: 2px;
          min-height: 80px;
          box-sizing: border-box;
          background: linear-gradient(165deg, rgba(81, 203, 255, .5), rgba(20, 120, 204, .5));
          border-radius: 16px;
          >div {
            position: absolute;
            top: 2px;
            left: 2px;
            display: flex;
            border-radius: 14px;
            width: calc(100% - 4px);
            background-color: #fff;
            /deep/ .el-textarea__inner {
              padding: 16px;
              height: 76px;
              max-height: 200px;
              border: 0;
              border-radius: 14px;
              font-size: 16px;
              resize: none;
            }
            img {
              margin: 18px 26px 18px 18px;
              width: 40px;
              height: 40px;
              cursor: pointer;
            }
          }
          
        }
      }
    }
    .fullscreenOverlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99999;
      display: none; /* 初始隐藏 */
      >div {
        margin-top: 200px;
        margin-left: 50%;
        transform: translate(-50%);
        width: 50%;
        height: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
      >i {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 24px;
        color: #fff;
      }
    }
    .fullscreenOverlay.active {
      display: block; /* 显示时显示 */
      background-color: rgba(0, 0, 0, 0.8); /* 可选：添加背景遮罩 */
      cursor: pointer;
    }
  }
}
</style>
